/**
 * "Framework guides" documentation section (launch-readiness B9 — AEO content).
 * One tutorial per top-8 framework, generated by the shared factory so every
 * page stays structurally identical and the i18n surface stays bounded.
 * Framework facts are truth-sourced from `docs/architecture/framework-support.md`.
 */
import { FRAMEWORK_GUIDES, frameworkGuidePage } from './pages/framework-guides.factory';

import type { DocSection } from './types';

export const FRAMEWORK_GUIDES_SECTION: DocSection = {
  id: 'framework-guides',
  titleKey: 'docs.section.fwguides.title',
  pages: FRAMEWORK_GUIDES.map(frameworkGuidePage),
};
